// extracted by mini-css-extract-plugin
module.exports = {"section":"d7","sectionContainer":"d8","card":"d9"};